import React, { forwardRef } from "react";

import classnames from "classnames";

import "./Button.scss";

type ButtonSize = "small" | "medium" | "large";
type ButtonColorType = "primary" | "secondary" | "destructive";
type ButtonType = "button" | "reset" | "submit";

interface ButtonProps extends React.HTMLAttributes<HTMLElement> {
  as?: "button" | "a" | "input" | "label" | React.FC;
  color?: ButtonColorType;
  "data-testid"?: string;
  disabled?: boolean;
  href?: string;
  pillButton?: boolean;
  isOutline?: boolean;
  size?: ButtonSize;
  type?: ButtonType;
  to?: string;
}

enum ButtonSizes {
  small = "sm",
  medium = "md",
  large = "lg",
}

export const Button = forwardRef(function Button(
  {
    as,
    children,
    className,
    color,
    isOutline,
    pillButton,
    size,
    type,
    ...rest
  }: ButtonProps,
  ref: any
) {
  const btnStyles = classnames(
    "btn",
    `btn--${color}`,
    `btn--${ButtonSizes[size]}`,
    isOutline ? "btn--outline" : "btn--solid",
    pillButton && "btn--pill",
    className
  );
  const Component = as;
  const typeProp = as === "a" ? {} : { type };

  return (
    <Component {...rest} {...typeProp} className={btnStyles} ref={ref}>
      {children}
    </Component>
  );
});

Button.defaultProps = {
  as: "button",
  isOutline: false,
  pillButton: false,
  size: "medium",
  color: "primary",
  type: "button",
};
